import * as component from '@mod-tollium/web/ui/js/componentbase';
const ComponentBase = component.ToddCompBase;
export default ComponentBase;
